import { ApiSourceType } from '~sharedLib'
import { IS_LOCAL_ENV } from '../env/constants/environment'
import { getEnvVar } from '../env/functions/getEnvVar'
import { API_PROXY_ENV_NAME_START, API_URL_ENV_NAME_START } from './apiUrlParts'

const apiStart = {
	[ApiSourceType.First]: 'FIRST_SOURCE',
	[ApiSourceType.Second]: 'SECOND_SOURCE'
}

export const getApiUrl = (type: ApiSourceType, useProxy?: boolean) => {
	return !IS_LOCAL_ENV || useProxy === false
		? (getEnvVar(`${API_URL_ENV_NAME_START}${apiStart[type]}`) as string)
		: (getEnvVar(`${API_PROXY_ENV_NAME_START}${apiStart[type]}`, true) as string)
}
